import { createFileRoute } from '@tanstack/react-router';

import { ReviewQueueScreen } from '@/features/case-reports/components/ReviewQueueScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/case-reports/review-queue')({
  beforeLoad: () => {
    requirePermission('case_report:review');
  },
  component: ReviewQueueRoute,
  staticData: { crumb: 'Review queue' },
});

function ReviewQueueRoute() {
  return <ReviewQueueScreen />;
}
